import { Checkbox, ListItemText, MenuItem, Select } from "@mui/material";
import React from "react";
import "../css/style.css";
import { colorBrandObject } from "../../constants/brandings";

function SelectDropdownCompo({
  value,
  onChange,
  width,
  options,
  label,
  selectAll,
}) {
  return (
    <Select
      className="filterDropdownGraph stylingDropdownGraph"
      sx={{
        width: width,
        fontFamily: "Poppins",
        height: "32px",
      }}
      multiple
      value={value}
      onChange={onChange}
      renderValue={(selected) => (
        <div style={{ fontSize: "14px" }}>{label}</div>
      )}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 250,
          },
        },
      }}
      classes={{ icon: "custom-dropdown-icon" }}
      displayEmpty
    >
      {
        options.length > 1 && (
          <MenuItem
            key={"Select All"}
            value={"Select All"}
            sx={{ width: width }}
            className="businessUnitCheckbox"
            style={{ padding: "5px 10px", height: "40px" }}
          >
            <Checkbox checked={selectAll}
              sx={{
                '& .MuiSvgIcon-root': {
                  color: colorBrandObject?.secondaryButtonColor,
                },
                '&.Mui-checked': {
                  color: colorBrandObject?.secondaryButtonColor,
                  '& .MuiSvgIcon-root': {
                    fill: colorBrandObject?.secondaryButtonColor,
                  },
                },
              }} />
            <ListItemText
              primary={"Select All"}
              sx={{
                marginLeft: "6px",
              }}
            />
          </MenuItem>
        )
      }
      {options?.map((optionType) => (
        <MenuItem
          key={optionType?.pspCodeLocale || optionType}
          value={optionType.pspCodeLocale || optionType}
          sx={{ width: width }}
          className="businessUnitCheckbox"
          style={{ padding: "5px 10px", height: "40px" }}
        >
          <Checkbox
            sx={{
              '& .MuiSvgIcon-root': {
                color: colorBrandObject?.secondaryButtonColor,
              },
              '&.Mui-checked': {
                color: colorBrandObject?.secondaryButtonColor,
                '& .MuiSvgIcon-root': {
                  fill: colorBrandObject?.secondaryButtonColor,
                },
              },
            }}
            checked={value.includes(optionType?.pspCodeLocale || optionType)}
          />
          <ListItemText
            primary={optionType?.pspCodeLocale || optionType}
            sx={{ marginLeft: "6px", fontFamily: "Poppins" }}
          />
        </MenuItem>
      ))}
    </Select>
  );
}

export default SelectDropdownCompo;
